export default __webpack_public_path__ + "static/media/undraw_web_shopping.adeaa16e.svg";